export const CloseIframeMessageType = 'CLOSE_IFRAME';
export const DialogTitleOverwriteIFrameMessageType = 'DIALOG_TITLE_OVERWRITE';
export const knownDialogTitleKeys = [
    'assets.assets.create-new-dialog.connector.dialog-title-overwrite.empty',
    'assets.assets.create-new-dialog.connector.dialog-title-overwrite.service-care',
] as const;
export type KnownDialogTitleKeys = (typeof knownDialogTitleKeys)[number];
export const DeviceTypeSearchParamType = 'device_type';
export const BrandSearchParamType = 'brand';
export const VehicleTypeSearchParamType = 'vehicle_type';
export const ExistingAssetIdSearchParamType = 'existing_asset_id';
export const StepSearchParamType = 'step';
export const TestAppSearchParamType = 'test-app';
export const SkipUpsellingSearchParamType = 'skip_upselling';
